import { styled } from '@mui/material'

export const Root = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
})
